import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import classes from "./LearnNavButton.module.scss";

/**
 * NavBar button that navigates to the Learning Modules gallery.
 * Placed in the NavBar right section next to Create Project.
 */
export default function LearnNavButton() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      id="learn-nav-button"
      className={classes.learnButton}
      onClick={() => navigate("/learn")}
    >
      <FontAwesomeIcon icon={faBookOpen} className={classes.icon} />
      <span className={classes.label}>Learn</span>
    </button>
  );
}
